export const noticeKind = {
  type: "string",
  enum: ["error", "info"]
};
